/* @flow */
import * as React from 'react';

const Close = ({ color = '#677BC5', ...props }) => (
  <svg width={28} height={28} viewBox="0 0 28 28" {...props}>
    <polygon
      stroke="none"
      strokeWidth={1}
      fill={color}
      fillRule="nonzero"
      points="28 2.83 25.17 0 14 11.17 2.83 0 0 2.83 11.17 14 0 25.17 2.83 28 14 16.83 25.17 28 28 25.17 16.83 14"
    />
  </svg>
);

export default Close;



// WEBPACK FOOTER //
// ./src/assets/images/icons/close.js